// extracted by mini-css-extract-plugin
export default {"declaracion":"Detail_declaracion__ZJD2S"};